import { Tool } from "./tools";

export const JSON_RESPONSE_SYSTEM_PROMPT = `You are an AI agent that responds ONLY in JSON, never returning additional text`;

export const build_tool_selection_prompt = (tools: Tool[]) => {
  let prompt = `You have access to the following tools:\n`;

  tools.forEach((tool) => {
    prompt += `- ${tool.name}: ${tool.selectionPrompt}\n`;
  });

  prompt += `\nReturn list of tool calls as follows: { t: <tool name>, i: <instructions> }[]`;

  return prompt;
};
